export default "__VITE_ASSET__CBp2A0Nb__"